let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bZ6uj")).then(() => parcelRequire('4sLin'));